export interface UserSummary {
  userId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

/** The user's first and last name, or their username when both are blank. */
export const getUserLabel = (user: UserSummary) =>
  [user.firstName?.trim(), user.lastName?.trim()].filter(Boolean).join(' ') ||
  user.userId;

/**
 * The users API filter for a picker search. Filters share one logical operator, so a name-or-email search can't sit
 * beside the AND filters around it: a search containing `@` matches the email, anything else the full name.
 */
export const getUserSearchFilter = (search: string) =>
  search.includes('@') ? `email:like:${search}` : `fullName:like:${search}`;
